export default __webpack_public_path__ + "static/media/flag-french-southern-territories.d72fa6b1.svg";